const DOCUMENT_PATH =
  /^\/modules\/document-workflow\/documents(?:\/([0-9a-f-]{36}))?$/i;
const ALLOWED_TABS = new Set([
  "timeline",
  "discussion",
  "files",
  "mail",
  "approval",
]);

/** Возвращает только известный внутренний маршрут, никогда не доверяя payload. */
export function notificationLink(value: string | null): string | null {
  if (
    value === null ||
    !value.startsWith("/") ||
    value.startsWith("//") ||
    value.includes("\\\\")
  )
    return null;
  try {
    const url = new URL(value, "https://erp.invalid");
    if (url.origin !== "https://erp.invalid") return null;
    const match = DOCUMENT_PATH.exec(url.pathname);
    if (
      url.pathname === "/administration/users" ||
      url.pathname === "/administration/users/list"
    ) {
      const user = url.searchParams.get("user");
      return user !== null && /^[0-9a-f-]{36}$/i.test(user)
        ? `/administration/users/list?user=${encodeURIComponent(user)}`
        : null;
    }
    if (match === null) return null;
    const documentId = match[1] ?? url.searchParams.get("document");
    if (documentId !== null && !/^[0-9a-f-]{36}$/i.test(documentId))
      return null;
    const tab = url.searchParams.get("tab");
    if (tab !== null && !ALLOWED_TABS.has(tab)) return null;
    const query = new URLSearchParams();
    if (documentId !== null) query.set("document", documentId);
    if (tab !== null) query.set("tab", tab);
    for (const key of ["message", "mail"] as const) {
      const id = url.searchParams.get(key);
      if (id !== null && /^[0-9a-f-]{36}$/i.test(id)) query.set(key, id);
    }
    return `/modules/document-workflow/documents${query.size === 0 ? "" : `?${query}`}`;
  } catch {
    return null;
  }
}

export function unreadLabel(count: number): string {
  return count >= 10 ? "10+" : String(count);
}
